import React from "react";
import { ArrowRight } from "lucide-react";

export const ClosingCTA = ({ fromPrice, registerUrl }) => {
  return (
    <section className="border-t hairline" data-testid="closing-cta">
      <div className="max-w-[1000px] mx-auto px-5 lg:px-8 py-14">
        <div className="rounded-3xl p-10 lg:p-12 text-center" style={{ background: "#364F6B" }}>
          <h2 className="text-white text-3xl lg:text-4xl font-bold leading-tight max-w-2xl mx-auto">Ready when you are</h2>
          <p className="text-white/75 mt-4 text-[15px] max-w-xl mx-auto leading-relaxed">
            Register free, sign your agreement, and activate representative services in the portal. Your exact pricing is always visible there.
          </p>
          <div className="mt-6 text-white/70 text-[14px]">Plans start at <span className="text-white font-bold text-lg">{fromPrice}</span></div>
          <a href={registerUrl} className="btn-aqua inline-flex items-center gap-2 px-8 py-3.5 text-[16px] mt-5" data-testid="closing-register">
            Register free <ArrowRight size={18} />
          </a>
          <div className="mt-5">
            <a href="https://gdprlocal.com/contact/" className="text-white/70 hover:text-aqua text-[14px] underline" data-testid="closing-talk-human">Or talk to a human</a>
          </div>
        </div>
      </div>
    </section>
  );
};
